import React, { useEffect, createContext, useContext } from 'react';
import { useTranslation } from '@weareconceptstudio/core';
import { ThemeProvider } from 'styled-components';
//* Translations
import translations from './translations';
//* Styles
import FormTheme from './styles/theme';
import FormVariables from './styles/variables';
import FormStyle from './styles/formStyle';
const FormContext = createContext(null);
export const useFormContext = () => {
    const context = useContext(FormContext);
    return context;
};
export const FormProvider = ({ fontFamily = 'core_Font', children, selectIcon }) => {
    const { addTranslation } = useTranslation();
    useEffect(() => {
        addTranslation(translations, 'prepend');
    }, []);
    return (React.createElement(FormContext.Provider, { value: { selectIcon } },
        React.createElement(ThemeProvider, { theme: FormTheme },
            React.createElement(FormVariables, { fontFamily: fontFamily }),
            React.createElement(FormStyle, null),
            children)));
};
//# sourceMappingURL=FormProvider.js.map